/**
 * Created by wuchang.liu on 2021/06/07.
 * 输入框的前缀或后缀
 */
import React, { Fragment } from 'react';
import classNames from 'classnames';
import { noNeedLocaleJS } from '@ok/blade';
import { Popover } from '@ok/okd';

import Create from '_common/components/Create';
import PopoverCuz from '_common/components/PopoverCustomize';

import styles from './index.module.less';

/**
 * @param {object} props 传入的props
 * @returns {dom} 输入框的前缀或后缀
 */
export default function PrefixSuffix(props) {
  const { text, description, className, isSuffix, style, disabled, sort } =
    props;
  const cN = classNames(
    styles.prefixSuffixBox,
    {
      [styles.disabled]: disabled,
      [styles.prefixSuffixBoxSuffix]: isSuffix,
    },
    className
  );

  return (
    <Fragment>
      <Create when={sort}>
        <span className={cN} style={style}>
          {noNeedLocaleJS(`${sort}. `)}
        </span>
      </Create>
      <Create when={description}>
        <PopoverCuz
          rebirthPopper
          alwaysUpdatePopper
          popperClassName="popUpMargin"
          size={Popover.SIZE.sm}
          description={description}
        >
          <span className={`${cN} has-popover`} style={style}>
            {text}
          </span>
        </PopoverCuz>
      </Create>
      <Create when={!description}>
        <span className={cN} style={style}>
          {text}
        </span>
      </Create>
    </Fragment>
  );
}
